export type ListProfile = {
  defaultPageSize: number
  pageSizes: readonly number[]
}

export const LIST_PROFILES = {
  heavy: { defaultPageSize: 25, pageSizes: [25, 50, 100] },
  standard: { defaultPageSize: 25, pageSizes: [25, 50, 100] },
  compact: { defaultPageSize: 50, pageSizes: [25, 50, 100] },
} as const satisfies Record<string, ListProfile>
